import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import '../mainAdminstyles.css';
import './styles.css';

import { getDatatypes } from '../../../../Actions/main';
import { saveSettings, manualUpdateSitemap } from '../../../../Actions/admin';

import { ButtonSimple } from '../../../Elements/Buttons';
import {MOBILE_MODE_GALLERY, MOBILE_MODE_MAP} from "../../../../consts";

class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentWillMount() {
        this.props.getDatatypes();
    }

    componentWillReceiveProps(nextProp) {
        if (nextProp.settings) {
            this.setState({
                mobileMode: nextProp.settings.mobileMode,
                chosenLabel: nextProp.settings.chosenLabel,
                zoom: nextProp.settings.zoom,
                mobileZoom: nextProp.settings.mobileZoom,
                lat: nextProp.settings.lat,
                lng: nextProp.settings.lng,
                maxClusterZoom: nextProp.settings.maxClusterZoom,
                maxClusterZoomMobile: nextProp.settings.maxClusterZoomMobile,
                initialPrice: nextProp.settings.initialPrice,
                maxPrice: nextProp.settings.maxPrice,
                clusterDistance: nextProp.settings.clusterDistance,
                clusterDistanceMobile: nextProp.settings.clusterDistanceMobile,
                bigSmallPinsDiff: nextProp.settings.bigSmallPinsDiff,
                textService: nextProp.settings.textService,
                textEvent: nextProp.settings.textEvent,
                textMusician: nextProp.settings.textMusician,
                textBand: nextProp.settings.textBand,
                dotSizesByZoom: nextProp.settings.dotSizesByZoom,
                contactEmail: nextProp.settings.contactEmail,
                liveMusicPagePins: nextProp.settings.liveMusicPagePins,
                liveMusicPagePinsMobile: nextProp.settings.liveMusicPagePinsMobile,
                liveMusicMapPins: nextProp.settings.liveMusicMapPins,
                liveMusicMapPinsMobile: nextProp.settings.liveMusicMapPinsMobile,
                // liveMusicFreePins: nextProp.settings.liveMusicFreePins,
                // liveMusicPushPins: nextProp.settings.liveMusicPushPins,
                // liveMusicRulePins: nextProp.settings.liveMusicRulePins,
                // liveMusicHugePins: nextProp.settings.liveMusicHugePins,
                servicePagePins: nextProp.settings.servicePagePins,
                servicePagePinsMobile: nextProp.settings.servicePagePinsMobile,
                serviceMapPins: nextProp.settings.serviceMapPins,
                serviceMapPinsMobile: nextProp.settings.serviceMapPinsMobile,
                // serviceFreePins: nextProp.settings.serviceFreePins,
                // servicePushPins: nextProp.settings.servicePushPins,
                // serviceRulePins: nextProp.settings.serviceRulePins,
                // serviceHugePins: nextProp.settings.serviceHugePins,
                bandPagePins: nextProp.settings.bandPagePins,
                bandPagePinsMobile: nextProp.settings.bandPagePinsMobile,
                bandMapPins: nextProp.settings.bandMapPins,
                bandMapPinsMobile: nextProp.settings.bandMapPinsMobile,
                // bandFreePins: nextProp.settings.bandFreePins,
                // bandPushPins: nextProp.settings.bandPushPins,
                // bandRulePins: nextProp.settings.bandRulePins,
                // bandHugePins: nextProp.settings.bandHugePins,
                musicianPagePins: nextProp.settings.musicianPagePins,
                musicianPagePinsMobile: nextProp.settings.musicianPagePinsMobile,
                musicianMapPins: nextProp.settings.musicianMapPins,
                musicianMapPinsMobile: nextProp.settings.musicianMapPinsMobile,
                // musicianFreePins: nextProp.settings.musicianFreePins,
                // musicianPushPins: nextProp.settings.musicianPushPins,
                // musicianRulePins: nextProp.settings.musicianRulePins,
                // musicianHugePins: nextProp.settings.musicianHugePins,
                liveMusicMinCounter: nextProp.settings.liveMusicMinCounter,
                serviceMinCounter: nextProp.settings.serviceMinCounter,
                bandMinCounter: nextProp.settings.bandMinCounter,
                musicianMinCounter: nextProp.settings.musicianMinCounter,
                contact: nextProp.settings.contact,
                joinUsText: nextProp.settings.joinUsText
            });
        }
    }

    onChangeHandler(event) {
        if (event.target.name.includes('dotSize-')) {
            const currentZoom = parseInt(event.target.name.replace('dotSize-', ''), 10);

            const newList = this.state.dotSizesByZoom.slice();
            newList[currentZoom - 1] = parseInt(event.target.value, 10);
            this.setState({dotSizesByZoom: newList});
            return;
        }

        // if (event.target.name === 'bigSmallPinsDiff') {
        //     this.setState({bigSmallPinsDiff: event.target.value});
        //     return;
        // }


        this.setState({
            [event.target.name]: event.target.value
        });

    }

    saveHandler() {
        if (!window.confirm('Are you sure you want to save those changes?')) return;

        this.props.saveSettings(this.props.token, this.state)
    }

    renderDotSizeInputs() {
        if (!this.props.settings || !this.state.dotSizesByZoom) return;
        return this.state.dotSizesByZoom.map((d, i) => {
            return (
                <div key={`zoom-${i}`} className="zoom-option-wrapper">
                    <label>{i + 1}</label>
                    <input
                        onChange={(event) => this.onChangeHandler(event)}
                        name={`dotSize-${i + 1}`}
                        type="number"
                        min="1"
                        max="100"
                        value={d || 0}
                    />
                </div>
            )
        })
    }

    render() {
        return (
            <div className="admin-wrapper settings-wrapper">
                <div className="content">
                    <div className="top-bar">
                        <div className="title">Settings</div>
                    </div>
                    <div style={{height: '40px'}}></div>
                    <div className="settings-nav-bar">Map Settings</div>
                    <div className="settings-inputs">
                        <div className="input-wrapper">
                            <label>Mobile Default Mode</label>

                            <div className="radio-wrapper">
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="mobileMode"
                                    type="radio"
                                    className="radio"
                                    value={MOBILE_MODE_GALLERY}
                                    checked={this.state.mobileMode === MOBILE_MODE_GALLERY}
                                />
                                <label htmlFor="gallery">Gallery</label>
                            </div>

                            <div className="radio-wrapper">
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="mobileMode"
                                    type="radio"
                                    className="radio"
                                    value={MOBILE_MODE_MAP}
                                    checked={this.state.mobileMode === MOBILE_MODE_MAP}
                                />
                                <label htmlFor="map">Map</label>
                            </div>

                        </div>
                        <div className="input-wrapper">
                            <label>Time label on map:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="chosenLabel"
                                type="text"
                                value={this.state.chosenLabel || ''}
                            />

                            <label>Map initial zoom:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="zoom"
                                type="number"
                                min="0"
                                max="20"
                                value={this.state.zoom || 0}
                            />
                            <label>Map initial mobile zoom:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="mobileZoom"
                                type="number"
                                min="0"
                                max="20"
                                value={this.state.mobileZoom || 0}
                            />
                        </div>
                        <div className="input-wrapper">
                            <label>Lat on map:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="lat"
                                type="number"
                                step="0.0000001"
                                value={this.state.lat || 0}
                            />

                            <label>Lng on map:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="lng"
                                type="number"
                                step="0.0000001"
                                value={this.state.lng || 0}
                            />

                            <label>Max zoom for clustering:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="maxClusterZoom"
                                type="number"
                                min="0"
                                max="20"
                                value={this.state.maxClusterZoom || 0}
                            />

                            <label>Max zoom for clustering mobile:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="maxClusterZoomMobile"
                                type="number"
                                min="0"
                                max="20"
                                value={this.state.maxClusterZoomMobile || 0}
                            />
                        </div>
                        <div className="input-wrapper">
                            <label>Initial price:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="initialPrice"
                                type="number"
                                min="0"
                                max="10000"
                                value={this.state.initialPrice || 0}
                            />

                            <label>Max price:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="maxPrice"
                                type="text"
                                min="0"
                                max="10000"
                                value={this.state.maxPrice || 0}
                            />
                            <label>Clustering distance:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="clusterDistance"
                                type="number"
                                min="0"
                                max="500"
                                value={this.state.clusterDistance || 0}
                            />
                            <label>Clustering distance mobile:</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="clusterDistanceMobile"
                                type="number"
                                min="0"
                                max="500"
                                value={this.state.clusterDistanceMobile || 0}
                            />
                        </div>
                    </div>
                    <div className="settings-inputs">
                        <div className="input-wrapper ">
                            <label>Small markers time delay (in seconds):</label>
                            <input
                                onChange={(event) => this.onChangeHandler(event)}
                                name="bigSmallPinsDiff"
                                type="number"
                                min="0"
                                max="30"
                                value={this.state.bigSmallPinsDiff || 0}
                            />
                        </div>
                    </div>
                    <div className="settings-inputs zoom-wrapper">
                        <p>Dot Sizes By Zoom (lowest is zoomed out)</p>
                        <div className="input-wrapper zoom">
                            {this.renderDotSizeInputs()}
                        </div>
                    </div>
                    <div className="section-header-wrapper">
                        <div className="settings-nav-bar">Mosaic Limits </div>
                        <div className="settings-nav-bar">Map Limits </div>
                    </div>

                    <div className="inner-section-content-wrapper">
                        <div className="side-by-side-wrapper">
                            <div className="vertical-section mobile">
                                <h3 className="sub-title">Mobile</h3>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="liveMusicPagePinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.liveMusicPagePinsMobile || 0}
                                        />
                                    </div>

                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="servicePagePinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.servicePagePinsMobile || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="bandPagePinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.bandPagePinsMobile || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="musicianPagePinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.musicianPagePinsMobile || 0}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className="vertical-section web">
                                <h3 className="sub-title">Desktop</h3>
                                <div className="settings-inputs">
                                    <div className="layout-type">Live Music:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="liveMusicPagePins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.liveMusicPagePins || 0}
                                        />
                                    </div>

                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Services:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="servicePagePins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.servicePagePins || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Bands:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="bandPagePins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.bandPagePins || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Musicians:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on One Page</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="musicianPagePins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.musicianPagePins || 0}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="side-by-side-wrapper">
                            <div className="vertical-section mobile">
                                <h3 className="sub-title">Mobile</h3>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="liveMusicMapPinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.liveMusicMapPinsMobile || 0}
                                        />
                                    </div>

                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="serviceMapPinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.serviceMapPinsMobile || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="bandMapPinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.bandMapPinsMobile || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="musicianMapPinsMobile"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.musicianMapPinsMobile || 0}
                                        />
                                    </div>

                                </div>
                            </div>
                            <div className="vertical-section web">
                                <h3 className="sub-title">Desktop</h3>
                                <div className="settings-inputs">
                                    <div className="layout-type">Live Music:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="liveMusicMapPins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.liveMusicMapPins || 0}
                                        />
                                    </div>

                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Services:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="serviceMapPins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.serviceMapPins || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Bands:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="bandMapPins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.bandMapPins || 0}
                                        />
                                    </div>
                                </div>
                                <div className="settings-inputs">
                                    <div className="layout-type">Musicians:</div>
                                    <div className="input-wrapper">
                                        <label>Pins on Map (in view)</label>
                                        <input
                                            onChange={(event) => this.onChangeHandler(event)}
                                            name="musicianMapPins"
                                            type="number"
                                            min="1"
                                            max="9999"
                                            value={this.state.musicianMapPins || 0}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="settings-nav-bar">General Limits</div>
                    <div className="vertical-section">
                        <h3 className="sub-title">Country Counter Display</h3>
                        <div className="settings-inputs">
                            <div className="layout-type">Live Music:</div>
                            <div className="input-wrapper">
                                <label>Min Pins</label>
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="liveMusicMinCounter"
                                    type="number"
                                    min="1"
                                    max="9999"
                                    value={this.state.liveMusicMinCounter || 0}
                                />
                            </div>

                        </div>
                        <div className="settings-inputs">
                            <div className="layout-type">Services:</div>
                            <div className="input-wrapper">
                                <label>Min Pins</label>
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="serviceMinCounter"
                                    type="number"
                                    min="1"
                                    max="9999"
                                    value={this.state.serviceMinCounter || 0}
                                />
                            </div>
                        </div>
                        <div className="settings-inputs">
                            <div className="layout-type">Bands:</div>
                            <div className="input-wrapper">
                                <label>Min Pins</label>
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="bandMinCounter"
                                    type="number"
                                    min="1"
                                    max="9999"
                                    value={this.state.bandMinCounter || 0}
                                />
                            </div>
                        </div>
                        <div className="settings-inputs">
                            <div className="layout-type">Musicians:</div>
                            <div className="input-wrapper">
                                <label>Min Pins</label>
                                <input
                                    onChange={(event) => this.onChangeHandler(event)}
                                    name="musicianMinCounter"
                                    type="number"
                                    min="1"
                                    max="9999"
                                    value={this.state.musicianMinCounter || 0}
                                />
                            </div>

                        </div>
                    </div>

                    <div className="settings-nav-bar">Text Editor</div>
                    <div className="settings-inputs">
                        <div className="input-wrapper">
                            <label>Main Popup live Music</label>
                            <textarea name="textEvent" value={this.state.textEvent || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                        <div className="input-wrapper">
                            <label>Main Popup Services</label>
                            <textarea name="textService" value={this.state.textService || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                        <div className="input-wrapper">
                            <label>Main Popup Musician</label>
                            <textarea name="textMusician" value={this.state.textMusician || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                        <div className="input-wrapper">
                            <label>Main Popup Band</label>
                            <textarea name="textBand" value={this.state.textBand || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                        <div className="input-wrapper">
                            <label>Contact</label>
                            <textarea name="contact" value={this.state.contact || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                        <div className="input-wrapper">
                            <label>Join Us Text</label>
                            <textarea name="joinUsText" value={this.state.joinUsText || ''} onChange={(e) => this.onChangeHandler(e)} cols="90" rows="4" />
                        </div>
                    </div>
                    <div className="settings-nav-bar">Contact Email</div>
                    <div className="settings-inputs">
                        <div className="input-wrapper email">
                            <input type="email" name="contactEmail" value={this.state.contactEmail || ''} onChange={(e) => this.onChangeHandler(e)} placeholder="Enter email" />
                        </div>
                    </div>
                    <div className="save-btn-wrapper">
                        <ButtonSimple onPress={() => this.saveHandler()} label="Save" />
                    </div>
                    <div className="save-btn-wrapper">
                        <ButtonSimple onPress={() => this.props.manualUpdateSitemap()} label="Update Sitemap" />
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    settings: state.main.datatypes && state.main.datatypes.defaults,
    token: state.users.token
});

Settings.propTypes = {
    // state to props
    settings: PropTypes.object,
    token: PropTypes.string,

    // actions
    getDatatypes: PropTypes.func,
    saveSettings: PropTypes.func
};


export default connect(mapStateToProps, {getDatatypes, saveSettings, manualUpdateSitemap})(Settings);



// WEBPACK FOOTER //
// ./src/Components/Screens/Admin/Settings/Settings.js